import React from "react";
import { useLocation } from "react-router-dom";
import AuthNavbar from "../components/common/AuthNavbar";

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const isScriptsRoute = location.pathname === "/scripts";

  return (
    <React.Fragment>
      <AuthNavbar />
      <div className="portal-layout portal-top-only-layout mt-14">
        <main
          className={`portal-main w-full overflow-y-auto ${
            isScriptsRoute
              ? "portal-main--scripts-auto"
              : "min-h-[calc(100vh-56px)]"
          }`}
        >
          {children}
        </main>
      </div>
    </React.Fragment>
  );
};

export default DashboardLayout;
